import { css } from '@emotion/core';
import { media, variables } from '@domain-group/fe-brary';
import * as designSystem from '@domain-group/fe-co-allhomes-design-system';
var colour = variables.colour;
export var body = /*#__PURE__*/css("margin:22px 0 28px;overflow-anchor:none;", media('>=tablet'), "{margin:0 0 10px;}");
export var stats = /*#__PURE__*/css("margin:55px 0 0;", media('>=tablet'), "{margin-bottom:60px;}");
export var info = /*#__PURE__*/css(designSystem.typography.bodySmall, " display:flex;color:", colour.neutral500, ";text-align:left;vertical-align:top;margin-bottom:0;", media('>=tablet'), "{margin-bottom:16px;}");
export var infoImage = {
  name: "w9p5dx",
  styles: "position:relative;top:3px;height:fit-content;"
};
export var message = {
  name: "1sugwtq",
  styles: "padding-left:5px;"
};